import stateExtender from '@/store/utils/stateExtender';
import RepositoryFactory from '@/services/repository-factory';
import datatableModule from '@/store/builder/datatableModule';
import table from '@/components/builders/configs/tables/specialOffersTable';
import filters from '@/components/builders/configs/filters/specialOffersFilters';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import offerModal from './submodules/offerModal';

const specialOffersRepository = RepositoryFactory.get('specialOffers');
const state = {
  repository: specialOffersRepository,
  error: null,
};

export default stateExtender({
  namespaced: true,
  state: () => state,
  modules: {
    table: datatableModule({
      fetch: specialOffersRepository.table,
      headers: table.headers.filter((header) => header.isShown),
      allHeaders: table.headers,
      options: {
        sortBy: ['id'],
        sortDesc: [true],
        itemsPerPage: 30,
      },
      search: filters,
    }),
    offerModal,
  },
  getters,
  mutations,
  actions,
});
